<template>
    <KRHPPaigutus>
        <template #pais>
            <v-row>
                <v-col>
                    <VoHoiatus class="ma-2"></VoHoiatus>
                    <h1 class="px-2">Õigused ja kohustused</h1>
                    <p class="px-2 text-textDark text-justify mt-3">Kriminaalhooldusalune on kohustatud järgima
                        kontrollnõudeid, täitma talle kohtuotsusega või ‑määrusega määratud kohustusi.
                        Karistusseadustiku paragrahvis seitsekümmend viis lõikes üks (KarS § 75 lg 1) sätestatud
                        kontrollnõuded laienevad kõikidele süüdlastele automaatselt, kui seadus näeb ette
                        käitumiskontrolli kohaldamise. Karistusseadustiku alusel on võimalik kohtul määrata ka erinevaid
                        kohustusi.
                        Kriminaalhooldusaluse õigused ja kohustused on Teile tutvumiseks ning kinnitamiseks. Küsimuste
                        tekkimisel palun pöörduge enda ametniku poole.
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-card>
                        <div class="text-center my-2" v-if="isLoading">
                            <v-progress-circular indeterminate></v-progress-circular>
                        </div>
                    </v-card>
                    <div v-if="!isLoading">
                        <div v-for="(tabel, i) in tabelid" :key="i" class="py-5">
                            <v-sheet :elevation="3" rounded>
                                <v-data-table class="rounded" v-model:expanded="tabel.laiendatud"
                                    :headers="tabel.paised" :items="tabel.kohustused" :items-per-page="tabel.lehePikkus"
                                    hide-default-footer show-expand fixed-header single-expand item-key="id">
                                    <template #expanded-row="{ item }">
                                        <tr class="sisu">
                                            <td>
                                            </td>
                                            <td>
                                                <p class="my-2"><b>Olek: </b>{{ item.olek }}</p>
                                                <p class="my-2"><b>Täitmise aeg: </b>{{ item.tahtaeg }}</p>
                                                <p v-if="item.lisainfo" class="my-2"><b>Lisainfo: </b>{{ item.lisainfo
                                                    }}
                                                </p>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-slot:bottom> </template>
                                </v-data-table>

                                <v-data-table class="rounded lisaRida" v-model:expanded="tabel.laiendatud"
                                    :headers="tabel.oigusePaised" :items="tabel.oigused"
                                    :items-per-page="tabel.lehePikkus" hide-default-footer show-expand fixed-header
                                    single-expand item-key="id">
                                    <template #expanded-row="{ item }">
                                        <tr class="sisu">
                                            <td colspan="2">
                                                <div v-html="item.html"></div>
                                            </td>
                                        </tr>
                                    </template>

                                    <template v-slot:headers> </template>
                                    <template v-slot:bottom> </template>
                                </v-data-table>
                            </v-sheet>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </template>
    </KRHPPaigutus>
</template>
<style scoped>
.lisaRida {
    background-color: var(--varv-lisa-3);
}

.sisu {
    background-color: var(--varv-valge);
}

::v-deep .v-data-table-rows-no-data {
    display: none;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import KRHPPaigutus from './uldine/KRHPPaigutus.vue';
import moment from 'moment';
import mixin from '@/core/mixins';
import { OigusedJaKohustusedTeenus } from '@/core/oigused-ja-kohustused-teenus';
import { Kohustus, Oigus } from '@/models/OiguseKohustuseArtikkel';

const _oigusedJaKohustusedTeenus = new OigusedJaKohustusedTeenus();

export class tabeliMudel {
    laiendatud: any[] | undefined;
    paised: any[] | undefined;
    oigusePaised: any[] | undefined;
    kohustused: Kohustus[] | undefined;
    oigused: Oigus[] | undefined;
    lehePikkus: number | undefined;
}

export default defineComponent({
    name: 'OigusedJaKohustused',
    components: { KRHPPaigutus },
    data() {
        return {
            moment: moment,
            isLoading: false,
            tabelid: [] as tabeliMudel[],
        }
    },
    mixins: [mixin],
    methods: {
        minuOigusedJaKohustusedInfo() {
            this.isLoading = true;
            _oigusedJaKohustusedTeenus.minuOigusedJaKohustused().then((oigusedKohustused) => {
                this.tabelid = oigusedKohustused.map((oigusKohustus) => {
                    return {
                        laiendatud: [],
                        paised: [
                            {
                                title: '',
                                key: 'data-table-expand',
                                width: 50,
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary'
                                }
                            },
                            {
                                title: oigusKohustus.arvelOlemiseAluseNimetus + (oigusKohustus.kohustused && oigusKohustus.kohustused.length > 0 ? " Määratud kohustused" : ""),
                                key: 'kohustuseNimetus',
                                sortable: false,
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary'
                                },
                            },
                        ],
                        oigusePaised: [
                            {
                                title: '',
                                key: 'data-table-expand',
                                width: 50,
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary'
                                }
                            },
                            {
                                title: '',
                                key: 'nimi',
                                sortable: false,
                                headerProps: {
                                    class: 'v-theme--VokTeema bg-primary'
                                },
                            },
                        ],
                        kohustused: oigusKohustus.kohustused,
                        oigused: oigusKohustus.oigused,
                        lehePikkus: -1
                    }
                });
            }).finally(() => {
                this.isLoading = false;
            });
        }
    },
    created() {
        this.moment = moment
    },
    mounted() {
        this.minuOigusedJaKohustusedInfo();
    }
});
</script>
